import { useCovers } from '@/api/hooks';
import { useMeOrThrow } from '@/app/MeContext';
import { Explainer } from '@/ui/context';
import { useWho } from '@/ui/who';
import { explainCoveringTask } from './explain';

/**
 * Who you are covering for, or who covers you, until when — and the tasks
 * a cover gave you (ADR-0114). Only the tasks: a cover makes nothing else
 * of theirs yours.
 */
export function Covering() {
  const me = useMeOrThrow();
  const who = useWho();
  const q = useCovers();
  const active = q.data?.mine.filter((c) => c.state === 'active') ?? [];
  const tasks = q.data?.tasks ?? [];
  if (active.length === 0 && tasks.length === 0) return null;
  return (
    <section className="flex flex-col border border-line" aria-label="Cover" data-testid="covering">
      <div className="flex flex-col gap-1 border-b border-line bg-raised px-5 py-3 text-dense">
        {active.map((c) =>
          c.coverer.id === me.humanId ? (
            <span key={c.id}>
              You are covering for <strong>{c.covered.displayName}</strong> until {c.endsOn}. Their new tasks come to you, marked as theirs.
            </span>
          ) : (
            <span key={c.id}>
              <strong>{c.coverer.displayName}</strong> covers you until {c.endsOn}. Your new tasks go to them meanwhile.
            </span>
          ),
        )}
      </div>
      {tasks.length > 0 && (
        <ul className="m-0 flex list-none flex-col gap-px bg-line p-0">
          {tasks.map((t) => (
            <li key={t.id} className="flex flex-col bg-page px-5 py-2 text-dense" data-testid="covering-task">
              <span className="flex flex-wrap items-baseline gap-3">
                <span className="flex-1">{t.title}</span>
                <span className="text-meta">meant for {t.meantFor.displayName}</span>
              </span>
              <Explainer context={explainCoveringTask(t, who)} />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
